/**
 * Switching the UI language — the three steps that must happen together, in this order.
 *
 * It lives outside MenuScene so the sequence is testable: Phaser cannot be imported in the node
 * test environment (see vitest.config.ts), and the ordering is the part that breaks. Getting it
 * wrong is silent — the board renders, just in the wrong lesson or with tofu glyphs.
 */
import i18next from 'i18next';
import { ensureScriptFont } from '@/game/fonts';
import { releaseActivePack } from '@/game/packs';

export async function switchLanguage(lang: string): Promise<void> {
  await i18next.changeLanguage(lang);
  // Fetch the Thai/JP/KR face before anything renders in it, or the first frame shows tofu.
  await ensureScriptFont(lang);
  // Forget the in-memory lesson so the next getActivePack() resolves for the NEW language. The
  // stored per-language picks survive — that is what returns a player to the lesson they left this
  // language on (see packs.ts). Placed last because that is the order things take effect, not
  // because it must be: getActivePack re-checks the pack's language too, so a release on either
  // side of changeLanguage gives the same lesson.
  releaseActivePack();
}
